var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFB6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2368 33.1071C12.2368 33.1071 0.333447 26.2394 2.85841 17.6815C3.86037 14.732 6.66588 12.6963 6.66588 12.6963C6.66588 12.6963 8.30911 3.59837 14.8419 4.01381C21.3748 4.42924 22.016 10.0376 22.016 10.0376C22.016 10.0376 22.6172 14.3996 24.02 15.6874C25.4227 16.9753 27.3866 20.4649 26.4648 22.5421C25.583 24.6192 33.0982 28.8813 27.4471 28.2582C21.7559 27.6766 12.2368 33.1071 12.2368 33.1071Z",
    fill: "#FF5B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5725 14.7313C20.5725 19.758 17.6468 23.8708 14.6008 23.8708C11.5548 23.8708 8.46875 19.7996 8.46875 14.7313C8.46875 9.66303 11.5147 5.5918 14.6008 5.5918C17.6869 5.5918 20.5725 9.70457 20.5725 14.7313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72701 18.3761C10.4676 17.7564 10.3917 16.3858 9.55757 15.3146C8.7234 14.2435 7.4468 13.8775 6.7062 14.4971C5.96561 15.1168 6.04147 16.4875 6.87564 17.5586C7.70982 18.6298 8.98642 18.9958 9.72701 18.3761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.416 17.5516C23.2501 16.4805 23.326 15.1098 22.5854 14.4901C21.8448 13.8704 20.5682 14.2364 19.734 15.3076C18.8999 16.3787 18.824 17.7494 19.5646 18.3691C20.3052 18.9888 21.5818 18.6228 22.416 17.5516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4829 8.54135L20.4527 16.4346L20.8935 12.488L19.4106 7.83511L16.3647 5.63332L13.0782 5.09326L9.47111 8.16746L8.06836 13.3188L8.50923 14.482C8.46915 14.3989 13.3187 13.7758 15.4829 8.54135Z",
    fill: "#FF5B65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0801 19.988C14.0801 19.988 15.2424 20.1957 16.0439 19.2817",
    stroke: "#ED737A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4,
    y1: 3.5,
    x2: 30,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D4DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2B1C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirl);
export default __webpack_public_path__ + "static/media/girl.3b721d301d91a0310186f75a386f0d53.svg";
export { ForwardRef as ReactComponent };